import WritingMessageIcon from 'packages/kakapo-ui-kit/assets/icons/WritingIcon';
import { TI, Trans } from 'react-i18next';
import styled from 'styled-components';
import AnswerCard from './AnswerCard';
import * as graphql from 'generated/graphql';
import AnswerLine from './AnswerLine';

const Container = styled.div`
	display: flex;
	flex-direction: row;
	gap: 10px;
	color: #6c7680;

	svg {
		opacity: 0.8;
	}
`;

export default function UnsharedAnswer({ participant }: { participant: graphql.Participant }) {
	const isRequester = participant.role === graphql.ConversationRole.Requester;
	const firstName = participant.user.firstName;

	return (
		<AnswerLine user={participant.user} side={isRequester ? 'left' : 'right'}>
			<AnswerCard variant="empty">
				<Container>
					<WritingMessageIcon color="#6C7680" />
					<p>
						<Trans i18nKey="evaluation.unsharedAnswer">
							<strong>{{ firstName } as TI}</strong> heeft nog geen antwoord met je gedeeld.
						</Trans>
					</p>
				</Container>
			</AnswerCard>
		</AnswerLine>
	);
}
